import * as React from 'react';
import { useStepper } from '../Stepper/Stepper';

interface IUploadStepContentProps {
  steps: {
    id: string;
    label: string;
    icon: React.ComponentType<any> | React.ReactNode;
    component: React.ReactNode;
  }[];
}

export const UploadStepContent: React.FunctionComponent<
  IUploadStepContentProps
> = (props) => {
  const { steps } = props;
  const { activeStep } = useStepper();
  return (
    <div className="rc-w-full rc-overflow-hidden">
      {steps[activeStep].component}
    </div>
  );
};

export default UploadStepContent;
